import { authedApiFetch } from '../utils/Api';

const inputSignalRulesService = {
	getInputSignalRules: async (
		subscribed = false,
		sortBy = 'created_at',
		sortOrder = 'desc'
	) => {
		const response = await authedApiFetch({
			endpoint: `/input_signal_rules?subscribed=${subscribed}&sort_column=${sortBy}&sort_order=${sortOrder}`,
			method: 'GET',
		});
		return response;
	},

	createInputSignalRule: async (params) => {
		const resp = authedApiFetch({
			endpoint: `/input_signal_rules`,
			method: 'POST',
			payload: params,
		});

		return resp;
	},

	createInputSignalRulesBulk: async (rules) => {
		const response = await authedApiFetch({
			endpoint: '/input_signal_rules_bulk',
			method: 'POST',
			payload: {
				input_signal_rules: rules,
			},
		});

		return response;
	},

	testInputSignalRule: async (params) => {
		const response = await authedApiFetch({
			endpoint: '/input_signal_rules/test',
			method: 'POST',
			payload: params,
			returnResponse: true,
		});

		const body = await response.json().catch(() => ({}));

		if (!response.ok || !body.success) {
			throw new Error(body.error || 'Alert test failed. Please try again.');
		}

		return body;
	},

	// Test Alert = dryRun: true | Run Now = dryRun: false
	runInputSignalRule: async ({ ruleId, dryRun = true }) => {
		const response = await authedApiFetch({
			endpoint: `/input_signal_rules/${ruleId}/run`,
			method: 'POST',
			payload: { dry_run: dryRun },
			returnResponse: true,
		});

		const body = await response.json().catch(() => ({}));

		if (!response.ok || !body.success) {
			throw new Error(body.error || 'Failed to run alert. Please try again.');
		}

		return body;
	},
	
	deleteInputSignalRule: async (alert_rule_id) => {
		const response = authedApiFetch({
			endpoint: `/input_signal_rules/${alert_rule_id}`,
			method: 'DELETE',
		});

		return response;
	},
};

export default inputSignalRulesService;
